import { networkIconFor } from '@alison/ui';
import type { ReactNode } from 'react';
import type { AdProvider } from '../../lib/adNetwork.hooks.js';

interface NetworkMarkProps {
  provider: AdProvider;
  size: number;
}

// Decorative: every call site renders the network name as text beside the mark,
// so SvgIcon's default aria-hidden is what we want.
export function NetworkMark({ provider, size }: NetworkMarkProps): ReactNode {
  const NetworkIcon = networkIconFor(provider);
  if (NetworkIcon === undefined) return null;
  return <NetworkIcon sx={{ fontSize: size, flexShrink: 0 }} />;
}
